import React from 'react';
const IconDropdown = () => {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L5 5L9 1" stroke="#000" strokeWidth="2"></path>
    </svg>
  );
};
export default IconDropdown;
